import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { getNowInZone } from '../helpers/countdown';

export const useCountdownClock = (zone: string): DateTime | null => {
  const [now, setNow] = useState<DateTime | null>(null);

  useEffect(() => {
    if (!zone) return;

    const tick = () => {
      const current = getNowInZone(zone);
      setNow(current);
      const msToNextMinute =
        60000 - (current.second * 1000 + current.millisecond);
      timer = setTimeout(tick, msToNextMinute);
    };

    let timer: ReturnType<typeof setTimeout>;
    tick();

    return () => clearTimeout(timer);
  }, [zone]);

  return now;
};
